/* c_newsletter-signup — メルマガ登録フォーム (issue #116)
   メッセージはセクションの data 属性から読みます（locales 由来・翻訳済み）。 */
(function () {
  'use strict';

  // type="email" は "a@b" のような TLD なしの値も通してしまうため、
  // ドメイン末尾が 2 文字以上であることまで確認します。
  // ローカル部のドットは連続・先頭・末尾を許可します。ドコモ/au の
  // 古い携帯アドレスに実在し、Shopify 側も受け付けるためです。
  var EMAIL_PATTERN = /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~.-]+@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;

  // 日本語 IME で入力された全角のメールアドレスを半角に直します。
  function toHalfWidth(value) {
    return value
      .replace(/[！-～]/g, function (char) {
        return String.fromCharCode(char.charCodeAt(0) - 0xfee0);
      })
      .replace(/　/g, ' ')
      .trim();
  }

  // 送信すると Shopify は action の「#フォームID」へ移動します。アンカーはフォーム自身、
  // つまり帯の中ほどを指すため、そのままでは完了メッセージが固定ヘッダーの裏に入ります。
  //
  // 送信を fetch で横取りする方法は使えません。この店舗では Shopify の
  // 不可視 CAPTCHA が有効で、トークンは Shopify 自身の送信処理でしか付かず、
  // 直接 POST すると 400「Missing CAPTCHA token」で弾かれるためです。
  //
  // そこで通常送信のまま、完了ページ側で帯を画面内に収めます。
  // 帯の上にある Instagram フィードは遅れて読み込まれて高さが変わるので、
  // 一度で位置を決めず、落ち着くまで追従します。
  function keepInView(root, message) {
    // フォーカスを移すとスクリーンリーダーが読み上げます。
    try {
      message.focus({ preventScroll: true });
    } catch (e) {
      /* preventScroll 非対応のブラウザでは何もしません */
    }

    var active = true;
    var align = function () {
      if (active) root.scrollIntoView({ block: 'start' });
    };
    var stop = function () {
      active = false;
      if (observer) observer.disconnect();
    };

    align();

    var observer = null;
    if (window.ResizeObserver) {
      observer = new ResizeObserver(align);
      observer.observe(document.documentElement);
    }
    window.addEventListener('load', align);

    // 利用者が操作を始めたら追従をやめます（勝手に動かさないため）。
    var endEvents = ['wheel', 'touchstart', 'keydown', 'pointerdown'];
    for (var i = 0; i < endEvents.length; i++) {
      window.addEventListener(endEvents[i], stop, { once: true, passive: true });
    }
    window.setTimeout(stop, 4000);
  }

  function setup(root) {
    if (root.dataset.cnsBound === 'true') return;
    root.dataset.cnsBound = 'true';

    var message = root.querySelector('.c_newsletter-signup__message');
    if (message) {
      keepInView(root, message);
      return; // 完了表示には入力欄が無いため、以降の処理は不要です
    }

    var form = root.querySelector('form');
    var input = root.querySelector('.c_newsletter-signup__input');
    var errorEl = root.querySelector('.c_newsletter-signup__error');
    if (!form || !input || !errorEl) return;

    var messageInvalid = root.dataset.messageInvalid || '';
    var messageRequired = root.dataset.messageRequired || '';

    // JS が動く場合はブラウザ標準の検証を止め、メッセージの見た目を統一します。
    // このファイルが読み込まれなかったときは type="email" と required がそのまま働きます。
    form.noValidate = true;

    function clearError() {
      errorEl.textContent = '';
      errorEl.classList.remove('is-visible');
      input.classList.remove('is-invalid');
      input.setAttribute('aria-invalid', 'false');
    }

    function showError(text) {
      errorEl.textContent = text;
      errorEl.classList.add('is-visible');
      input.classList.add('is-invalid');
      input.setAttribute('aria-invalid', 'true');
    }

    function normalize() {
      var normalized = toHalfWidth(input.value);
      if (normalized !== input.value) input.value = normalized;
      return normalized;
    }

    input.addEventListener('blur', function () {
      var value = normalize();
      if (value === '' || EMAIL_PATTERN.test(value)) clearError();
    });

    input.addEventListener('input', function () {
      if (errorEl.classList.contains('is-visible')) clearError();
    });

    form.addEventListener('submit', function (event) {
      var value = normalize();
      if (value === '' || !EMAIL_PATTERN.test(value)) {
        event.preventDefault();
        showError(value === '' ? messageRequired : messageInvalid);
        input.focus();
        return;
      }
      clearError();
      // ここから先は Shopify の通常送信に任せます（CAPTCHA トークンのため）。
    });
  }

  function init() {
    var sections = document.querySelectorAll('.c_newsletter-signup');
    for (var i = 0; i < sections.length; i++) setup(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // テーマエディタでセクションを編集し直したときに再バインドします。
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.c_newsletter-signup');
    if (root) setup(root);
  });
})();
